import styled from 'styled-components';

export const AdminFeedbackCyclePageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  background-image: linear-gradient(100deg, rgba(78, 84, 107, 1), #ab4f6d);
  height: 283px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
`;

export const BreadCrumbsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 24px;

  h3 {
    font-size: 0.8rem;
    font-weight: 600;
    line-height: 1.83;
    letter-spacing: 0.2px;
    color: rgba(255, 255, 255, 1);
    opacity: 0.65;
    margin: 0;
    text-transform: uppercase;
  }

  h2 {
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
    margin: 0;
    margin-bottom: 12px;
  }
`;

export const StatusBoxContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
`;

export const HeaderContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 1 auto;
`;
